export default __webpack_public_path__ + "static/media/slide.5665dde9.png";